import angular from 'angular';
import 'angular-animate';
import 'ng-pickadate';
import 'angular-moment';
import 'ng-handsontable';
import {vrmTemplateModule} from '@/angular/modules/vrm.template';
import {vrmVueModule} from '@/angular-bridge/module';

export const vrmComponentsModule = angular.module('vrm.components', [
    vrmTemplateModule.name,
    vrmVueModule.name,
    'ngAnimate',
    'pickadate',
    'angularMoment',
    'ngHandsontable',
]);

const context = require.context('./vrm-components/', true, /\.js/);

context.keys()
    .forEach(moduleDescription => {
        context(moduleDescription);
    });
